import * as React from 'react'
import { TaskSummaryMainConnected } from './TaskSummaryMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskSummaryMainExamples = () => {
  return (
    <div className="TaskSummaryMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSummaryMainConnected />
      </Provider>
    </div>
  )
}
